import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-26bb2860")

_pushScopeId("data-v-26bb2860")
const _hoisted_1 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "#2c3e50",
  class: "bi bi-caret-right-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createVNode("path", { d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "#2c3e50",
  class: "bi bi-bullseye",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }),
  /*#__PURE__*/_createVNode("path", { d: "M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10zm0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" }),
  /*#__PURE__*/_createVNode("path", { d: "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" }),
  /*#__PURE__*/_createVNode("path", { d: "M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: { cell: true },
    style: {
            width: `${_ctx.cellSize}px`,
            height: `${_ctx.cellSize}px`,
            backgroundColor: _ctx.cell.color,
            transition: 'background-color ease-in-out 300ms',
            'border-right': _ctx.cell.drawBorder ? `solid ${_ctx.cell.borderColor}` : '',
            'border-bottom': _ctx.cell.drawBorder ? `solid ${_ctx.cell.borderColor}` : '',
            'border-width': _ctx.cell.drawBorder ? 'thin' : '',
        },
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args))),
    onMouseover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mouseOverHandler && _ctx.mouseOverHandler(...args))),
    onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.dropOverCell && _ctx.dropOverCell(...args))),
    onDragenter: _cache[6] || (_cache[6] = (e) => e.preventDefault()),
    onDragover: _cache[7] || (_cache[7] = (e) => e.preventDefault()),
    id: `cell-${_ctx.cell.row}-${_ctx.cell.col}`
  }, [
    (_ctx.isStartNode)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          draggable: true,
          class: "target-node",
          onDragstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragStarted && _ctx.dragStarted(...args)))
        }, [
          _hoisted_1
        ], 32))
      : (_ctx.isEndNode)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            draggable: true,
            class: "target-node",
            onDragstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dragStarted && _ctx.dragStarted(...args)))
          }, [
            _hoisted_2
          ], 32))
        : _createCommentVNode("", true)
  ], 44, ["id"]))
})